import { ReactNode } from 'react';
import { UISnackbar } from '..';
import useStyles from '../../assets/styles/App.css';

/**
 *
 *
 *
 * @method Interface
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
type Props = {
  children: ReactNode;
};

/**
 *
 *
 *
 * @method LayoutComponents
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
const SigninLayout = (props: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <UISnackbar />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
};

export default SigninLayout;
